import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { FieldInput } from "@/components/CrudSection";
import { fmtDate } from "@/lib/format";

export const OWNERSHIP = { PROPRIETA: "Proprietà", NOLEGGIO: "Noleggio", LEASING: "Leasing" };
export const V_STATUS = { ACTIVE: "In uso", TO_SCRAP: "Da rottamare", TO_RETURN: "Da riconsegnare", SCRAPPED: "Rottamato", RETURNED: "Riconsegnato", SOLD: "Venduto" };
export const COST_KINDS = { FUEL: "Carburante", MAINTENANCE: "Manutenzione", INSURANCE: "Assicurazione", TAX: "Bollo", RENT: "Canone noleggio/leasing", FINE: "Multa", OTHER: "Altro" };
export const MAINT_KINDS = { TAGLIANDO: "Tagliando", GOMME: "Cambio gomme", FRENI: "Freni", CARROZZERIA: "Carrozzeria", GUASTO: "Riparazione guasto", ALTRO: "Altra manutenzione" };
export const EQUIP_KINDS = { GIUNTATRICE: "Giuntatrice", OTDR: "OTDR", POWER_METER: "Power meter", SCALA: "Scala", TELEFONO: "Telefono aziendale", SIM: "SIM", PC: "Computer", TABLET: "Tablet", ALTRO: "Altro" };
export const EQUIP_STATUS = { ACTIVE: "In uso", REPAIR: "In riparazione", DISMISSED: "Dismessa" };
export const LEVELS = {
  OVERDUE: ["Scaduto", "bg-red-600 text-white"], TODAY: ["Scade oggi", "bg-red-100 text-red-800"],
  D7: ["Entro 7 gg", "bg-amber-100 text-amber-900"], D30: ["Entro 30 gg", "bg-yellow-50 text-yellow-800"], OK: ["OK", "bg-emerald-50 text-emerald-800"],
};
export const opts = (map) => Object.entries(map).map(([value, label]) => ({ value, label }));

export const LevelBadge = ({ level, testId }) => {
  const [label, cls] = LEVELS[level] || LEVELS.OK;
  return <span data-testid={testId} className={`whitespace-nowrap px-1.5 py-0.5 text-[11px] font-semibold uppercase ${cls}`}>{label}</span>;
};

export const DueCell = ({ date, level }) => (
  <span className={`font-mono text-xs ${level === "OVERDUE" || level === "TODAY" ? "font-bold text-red-700" : level === "D7" ? "font-semibold text-amber-700" : level === "D30" ? "text-yellow-700" : ""}`}>
    {date ? fmtDate(date) : "—"}
  </span>
);

export const FormDialog = ({ open, onClose, title, fields, form, setForm, onSave, testPrefix }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-h-[90vh] max-w-2xl overflow-y-auto" data-testid={`${testPrefix}-dialog`}>
      <DialogHeader><DialogTitle className="font-display text-2xl">{title}</DialogTitle></DialogHeader>
      <div className="grid gap-4 sm:grid-cols-2">
        {fields.map((f) => (
          <div key={f.key} className={f.wide ? "sm:col-span-2" : ""}>
            <Label className="micro-label">{f.label}</Label>
            <FieldInput f={f} value={form[f.key]} onChange={(v) => setForm((s) => ({ ...s, [f.key]: v }))} testPrefix={testPrefix} />
          </div>
        ))}
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={onClose}>Annulla</Button>
        <Button onClick={onSave} data-testid={`${testPrefix}-save-button`}>Salva</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
